import { writable } from "svelte/store";
import { writableLocalStorage } from "./localstorageutil";
import "./sessionstorageutil";
import { Language } from "../dictionary/Language";
export const current_expanded_result_id = writable(-1);
export const is_online = writable(true);
export const languages = writable([]);
export const current_dialect = writableLocalStorage("current_dialect", new Language({
    "id": 2,
    "name": "Sanremasco",
    "short_name": "srm",
    "municipality_name": "Sanremo",
    "iso_code": "lij-x-srm",
    "disabled": false
}));
export const italian_language = writable(null);
export const genders = writable([]);
export const numbers = writable([]);
export const lexical_categories = writable([]);
export const scopes = writable([]);
export const auth_token = writableLocalStorage("token", "");
// 0 == not set, 1 == accepted, -1 == refused
export const allow_analytics = writableLocalStorage("allow_analytics", 0);
